import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ListFiltersComponent } from 'elbuild-ui-componentslib';
import { ParamsService } from 'elbuild-ui-lib-core';

@Component({
	selector: 'app-conf-list-filters',
	templateUrl: './conf-list-filters.component.html',
	styleUrls: ['./conf-list-filters.component.scss']
})
export class ConfListFiltersComponent extends ListFiltersComponent implements OnInit {

	constructor(
		router: Router,
		_route: ActivatedRoute,
		paramsService: ParamsService
	) {
		super(router, _route, paramsService);

	}

	ngOnInit() {
	}

	readQueryParams(params: string) {
		super.readQueryParams(params);
	}

	resetSearch() {
		super.resetSearch();
	}

	search(keeppage?: boolean) {

		super.search(keeppage);
	}



}
